import React from 'react';

import Box from '@atlaskit/primitives/box';
// eslint-disable-next-line @townsquare/rules/no-xcss
import { xcss } from '@atlaskit/primitives/xcss';

const styles = xcss({
	gridArea: 'breadcrumbs',
	marginBlockEnd: 'space.050',
	minWidth: '0',
});

export const Breadcrumbs = ({ children }: React.PropsWithChildren<unknown>): React.JSX.Element => {
	return <Box xcss={styles}>{children}</Box>;
};
